<template>
  <div id="app">
    <!-- 导航栏 -->
    <NavBar @open-order="showOrderModal = true" />

    <!-- 页面内容出口 -->
    <router-view />

    <!-- 底部页脚 -->
    <Footer />

    <!-- 下单弹窗 -->
    <OrderModal
      :visible="showOrderModal"
      @close="showOrderModal = false"
    />

    <!-- 加盟弹窗 -->
    <JoinModal
      :visible="showJoinModal"
      @close="showJoinModal = false"
    />
  </div>
</template>

<script>
import NavBar from './components/navBar.vue'
import Footer from './components/footer.vue'
import OrderModal from './components/orderModal.vue'
import JoinModal from './components/joinModal.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Footer,
    OrderModal,
    JoinModal
  },
  data() {
    return {
      // 弹窗控制
      showOrderModal: false,
      showJoinModal: false
    }
  },
  mounted() {
    this.$root.$on('openOrder', () => {
      this.showOrderModal = true
    })
    this.$root.$on('openJoin', () => {
      this.showJoinModal = true
    })
  }
}
</script>
<style lang="scss">
#app {
  font-family: Source Han Sans SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #313131;
  min-height: 100vh;
  width: 100%;
}
</style>